import React, { useState } from 'react'
import { TypographyProvider } from 'app/react/components/typography/TypographyContext'

export default function TypographyContainer ({
  children,
  headerTitle = '',
  headerText = '',
  selectLabel = '',
  selectOptions = [],
  initialOption = '',
  fonts = [],
  texts,
}) {

  const [selectedOption, setSelectedOption] = useState(initialOption)

  const contextObjext = {
    headerTitle: headerTitle,
    headerText: headerText,
    selectLabel: selectLabel,
    selectOptions: selectOptions,
    selectedOption: selectedOption,
    setSelectedOption: setSelectedOption,
    fonts: fonts,
    texts: texts,
  }

  return (
    <TypographyProvider value={contextObjext}>
      {children}
    </TypographyProvider>
  )
}
